<mat-dialog-content>
    <auth-element loginUrl="{{baseUrl}}" configfile="{{configfile}}" roleUser="{{roleUser}}" apiUrl={{cityUrl}} (auth)="processAuth($event)">
    </auth-element>
</mat-dialog-content>